<template>
    <div :id="id">
        <select class="form-control" name="country" ref="countriesSelect" style="width: 100%;"></select>
    </div>
</template>

<script>
import $ from 'jquery';
import 'select2';
import { mapGetters, mapActions } from 'vuex'

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null
        },
        id: {
            type: String,
            required: false,
            default: () => {
                // Generate random ID to be sure country select behaves propertly when rendered more than once on same page
                return (Math.random() + 1).toString(36).substring(7)
            }
        }
    },
    mounted () {
        this.getCountries()
    },
    methods: {
        ...mapActions('countries', [
            'getCountries'
        ]),
        buildCountriesList () {
            const vm = this
            this.$nextTick(() => {
                $(this.$refs.countriesSelect)
                    .select2({
                        theme: 'bootstrap',
                        data: vm.countries,
                        allowClear: false,
                        dropdownParent: $(`#${this.id}`),
                        language: {
                            errorLoading: function() {
                                return trans('clients.select_1')
                            },
                            loadingMore: function() {
                                return trans('clients.select_2')
                            },
                            noResults: function() {
                                return trans('clients.select_3')
                            },
                            searching: function() {
                                return trans('clients.select_4')
                            }
                        },
                    })
                    .on('select2:select', function(e) {
                        vm.$emit('input', e.params.data.id)
                    })
                    .on('change', function () {
                        const value = vm.$refs.countriesSelect.value
                        if (value) {
                            vm.$emit('input', value)
                        }
                    })
                    .on('select2:clear', function () {
                        vm.$emit('input', '')
                    });

                $(this.$refs.countriesSelect).val(vm.value ? vm.value : this.defaultCountry).trigger('change');
            });
        }
    },
    computed: {
        ...mapGetters({
            countries: 'countries/countries',
            hasLoadedCountries: 'countries/hasLoaded',
            defaultCountry: 'countries/defaultUserCountry'
        })
    },
    watch: {
        value (value) {
            if (this.$refs.countriesSelect) {
                $(this.$refs.countriesSelect).val(value ? value : this.defaultCountry).trigger('change')
            }
        },
        hasLoadedCountries: {
            handler (value) {
                if (value) {
                    this.buildCountriesList()
                }
            },
            immediate: true
        }
    }
};
</script>
